<template>
  <div class="vod-player" :key="'vodplayer'">

    <!-- 프로그램 정보 레이어 팝업 -->
    <transition v-if="showVodInfo" name="vod-info">
      <div class="popup-back" id="vod-pop" style="display: block;">
        <!-- 제목 1줄 info01 -->
        <div class="popup pop-vod-info01">
          <div class="popup-button-close">
            <a @click.prevent="closeVodInfo()" href="#">
              <img src="../../assets/images/common/btn-popup-close.png" alt="btn-close">
            </a>
          </div>
          <div class="pop-top gradation-purple">
            <strong>{{ contentInfo.programtitle }}</strong>
            <ul>
              <li>{{ contentInfo.channelname }}</li>
              <li>{{ contentInfo.releaseweekday }}</li>
              <li>{{ contentInfo.programstarttime }} ~ {{ contentInfo.programendtime }}</li>
            </ul>
          </div>
          <div class="pop-contents">
            <p v-html="programContent(contentInfo.programsynopsis)"></p>
          </div>
        </div>
      </div>
    </transition>

    <!-- 플레이어 콘텐츠 영역 -->
    <div class="video-wrap" v-adjust-height>
      <div class="player-top-contents">
        <div id="container" ref="container" class="video-container"></div>
      </div>

      <!-- 우측 정보 영역 -->
      <div class="player-bottom-contents" ref="programInfo">
        <h2>
          <span class="episode-number">{{ changeEscapeCharacter(getValue('seasontitle')) }}</span>
        </h2>

        <div class="player-bottom-utils">
          <player-action-button v-if="contentInfo" content-type="vod" :content-info="contentInfo" :key="contentid"></player-action-button>
        </div>

        <p class="program-info-box" v-vod-info-box="{ 'info': contentInfo, 'type': isVod ? 'vod' : 'global' }"></p>

        <div v-if="!isPooqzone" class="icon-box">
          <ul>
            <li class="icon-item" v-if="contentInfo.downloadable.toUpperCase() === 'Y'">
              <a href="#" @click.prevent="openDownloadPopup">
                <img src="../../assets/images/common/download.png" alt="다운로드">
                <span class="icon-txt">다운로드</span>
              </a>
            </li>
            <li class="icon-item">
              <a href="#" @click.prevent="openSharePopup">
                <img src="../../assets/images/common/share.png" alt="공유">
                <span class="icon-txt">공유</span>
              </a>
            </li>
            <li>
              <btn-zzim-with-api :isOn="getValue('zzim')" :block-zzim="getValue('programid') === ''"
                        contentsType="program" :contentsId="getValue('programid')" :key="getValue('contentid')"/>
            </li>
          </ul>
        </div>

        <div v-if="contentInfo.synopsis" class="content-preview-box">
          <strong class="comment">{{ comment }}</strong>
          <span v-html="contentInfo.synopsis" class="preview"></span>
        </div>

        <div v-if="getList(['actors','list']).length > 0" class="content-actor-box">
          <strong>출연</strong>
          <template v-for="(actor, index) in getList(['actors', 'list'])">
            <span :key="index" class="content-actor-list">
              <a @click.prevent="searchText(actor.text.trim())" href="#">{{ actor.text }}</a>
            </span>
            <template v-if="index !== getList(['actors', 'list']).length - 1">, </template>
          </template>
        </div>

        <div class="detail-view-box">
          <button type="button" class="info-toggle-button" v-if="!viewMoreState" @click.prevent="toggleViewMore">
            <span>더보기</span>
            <img src="../../assets/images/common/arrow-more-16-open.png" alt="열기">
          </button>
          <button type="button" class="info-toggle-button" v-if="viewMoreState" @click.prevent="toggleViewMore">
            <span>간략히</span>
            <img src="../../assets/images/common/arrow-more-16-close.png" alt="닫기">
          </button>

          <div class="detail-view-content" v-if="viewMoreState">
            <div class="detail-view-content-img">
              <img :src="getValue('programposterimage') | url" width="88" height="126" :alt="getValue('title')">
            </div>

            <div class="detail-view-content-txt">
              <div class="detail-view-content-synopsis">
                <strong>{{ getValue('seasontitle') }}</strong>
                <p v-html="getValue('seasonsynopsis')"></p>
              </div>
              <table>
                <caption>프로그램 정보</caption>
                <colgroup>
                  <col>
                  <col>
                </colgroup>
                <tbody>
                  <tr>
                    <th>
                      <span>개요</span>
                    </th>
                    <td>
                      <span>{{summary}}</span>
                    </td>
                  </tr>
                  <tr v-if="getList(['tags', 'list']).length > 0">
                    <th>
                      <span>장르</span>
                    </th>
                    <td>
                      <a v-for="(tag, index) in contentInfo.tags.list" :key="index"
                         @click.prevent="tagSearchUrl(tag)" href="#" class="genre">
                        #{{ tag.text.trim() }}{{index !== contentInfo.tags.list.length - 1 ? ',&nbsp;' : ''}}
                      </a>
                    </td>
                  </tr>
                  <tr v-if="directorList.length > 0">
                    <th>
                      <span>감독</span>
                    </th>
                    <td>
                      <a v-for="(director, index) in directorList" :key="index"
                         @click.prevent="searchText(director.text)" href="#" class="genre">
                        {{ director.text.trim() }}{{index !== directorList.length - 1 ? ',&nbsp;' : ''}}
                      </a>
                    </td>
                  </tr>
                  <tr v-if="writerList.length > 0">
                    <th>
                      <span>작가</span>
                    </th>
                    <td>
                      <a v-for="(writer, index) in writerList" :key="index"
                         @click.prevent="searchText(writer.text)" href="#" class="genre">
                        {{ writer.text.trim() }}{{index !== writerList.length - 1 ? ',&nbsp;' : ''}}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--
          * toggleState에 따라서 상단 .detail-view-box 영역 open, close
          -->
        </div>

        <player-notice :content-id="contentInfo.programid"></player-notice>
      </div>
    </div>
  </div>
</template>

<script>
import PlayerNotice from '@/components/player/PlayerNotice'
import PlayerActionButton from '@/components/player/PlayerActionButton'
import {
  addPostfixAndUrl,
  destroyPlayer, detachPlayerEvents,
  getUserInfo,
  setDisableScrolling,
  setEnterChange,
  changeEscapeCharacter
} from '@/common/utils/common'
import { mapGetters } from 'vuex'
import cookie from '@/common/utils/cookie'
import _ from 'lodash'
import { getNoneCredentialUserInfo, playerDelegate } from '@/common/utils/scalable.player'
import { LOGIN_SUCCESS_EVENT, MENU, PLAYER_UPDATE_EVENT } from '@/common/resources/const'
import { vodInfoBox, adjustHeight } from '@/common/resources/directives'
import BtnZzimWithApi from '@/components/button/BtnZzimWithApi'
import { PATH_NAME_PLAYER_LIVE, PATH_NAME_SEARCH, PATH_NAME_SEARCH_TAG_GROUP } from '@/common/resources/router.const'
import { url } from '@/common/filters/url.filter'

export default {
  name: 'VodPlayer',
  components: {
    BtnZzimWithApi,
    PlayerActionButton,
    PlayerNotice
  },
  filters: {
    addPostfixAndUrl,
    url
  },
  directives: {
    vodInfoBox,
    adjustHeight
  },
  props: {
    contentInfo: {
      type: Object
    },
    dataOrderInfo: {
      type: Object
    },
    isPlayAd: {
      type: Boolean
    },
    openDownloadPopup: {
      type: Function
    },
    openShareLayout: {
      type: Function
    },
    openSharePopup: {
      type: Function
    }
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn(),
      viewMoreState: false,
      showVodInfo: false // 프로그램 상세 정보
    }
  },
  computed: {
    ...mapGetters(['currentMenu']),
    logoStyle () {
      return 'background-image:url(' + location.protocol + '//' + this.contentInfo.image + ');'
    },
    contentid () {
      return _.get(this.contentInfo, 'contentid', '')
    },
    isVod () {
      return this.currentMenu === MENU.BROADCAST
    },
    isGlobalVod () {
      return this.currentMenu === MENU.GLOBAL
    },
    summary () {
      const { channelname = '', releasedate = '', nation = '', releaseyear = '' } = this.contentInfo
      const year = releasedate !== '' ? releasedate.substring(0, 4) : releaseyear
      const yearInfo = year.length > 0 ? `${year}년` : ''
      return [channelname, nation, yearInfo].filter(infoText => infoText !== '').join(', ')
    },
    directorList () {
      return _.get(this.contentInfo, 'directors.list', [])
    },
    writerList () {
      return _.get(this.contentInfo, 'writers.list', [])
    },
    comment () {
      return _.get(this.contentInfo, 'comment', '')
    }
  },
  methods: {
    changeEscapeCharacter,
    getValue (path) {
      return _.get(this.contentInfo, path, '')
    },
    getList (path) {
      return _.get(this.contentInfo, path, [])
    },
    clickVodInfo () {
      setDisableScrolling(true) // 윈도우 스크롤 방지
      this.showVodInfo = true
    },
    closeVodInfo () {
      setDisableScrolling(false) // 윈도우 스크롤 사용
      this.showVodInfo = false
    },
    toggleViewMore () {
      this.viewMoreState = !this.viewMoreState
    },
    // 플레이어 초기화
    playerInit () {
      // destroyPlayer()
      // destroyPlayer()
      if (cookie.getCredential() === 'none') {
        window.playerInstance.setUserInfo(getNoneCredentialUserInfo())
        window.playerInstance.load(this.contentInfo.type === 'onair' ? 'onairvod' : 'vod', this.contentInfo.contentid)
      } else {
        getUserInfo().then((userInfo) => {
          window.playerInstance.setUserInfo(userInfo)
          window.playerInstance.load(this.contentInfo.type === 'onair' ? 'onairvod' : 'vod', this.contentInfo.contentid)
        })
      }
    },
    // 태그 값에 맞는 태그 검색 페이지 URL 리턴
    tagSearchUrl (tag) {
      this.$router.push({
        name: PATH_NAME_SEARCH_TAG_GROUP,
        query: {
          tag: tag.value,
          text: tag.text,
          list: 'vod',
          contentid: this.contentInfo.contentid
        }
      })
    },
    programContent (data) {
      return data !== '' ? setEnterChange(data) : '프로그램 정보가 없어요.'
    },
    moveToLive (channelId) {
      this.$router.push({
        name: PATH_NAME_PLAYER_LIVE,
        query: {
          channelid: channelId
        }
      })
    },
    searchText (searchWord) {
      this.$router.push({
        name: PATH_NAME_SEARCH,
        query: {
          searchWord: searchWord
        }
      })
    }
  },
  mounted () {
    this.$events.$on(LOGIN_SUCCESS_EVENT, () => { location.reload() })
    // playerDelegate(this)
    playerDelegate(this, this.$refs.container)
  },
  updated () {
    this.$refs.programInfo.scrollTo(0, 0)
  },
  beforeDestroy () {
    this.$events.$off(PLAYER_UPDATE_EVENT)
    this.$events.$off(LOGIN_SUCCESS_EVENT)
    detachPlayerEvents()
    destroyPlayer()
  }
}
</script>
